import { render, staticRenderFns } from "./GeneralSettingCloudinaryName.vue?vue&type=template&id=5e50a5f1&"
import script from "./GeneralSettingCloudinaryName.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingCloudinaryName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports